import { createAction, props } from "@ngrx/store";

import { Cart } from "../../app/feutures/cart/interface/cart";
export const loadCart = createAction (
    '[Cart] Load Cart ',
    
);


export const loadCartSuccess = createAction(
  '[Cart] Load Success',
  props<{ cart: Cart; numOfCartItems: number }>()
);


// Add / Remove

export const addCartProduct = createAction(
  '[Cart] Add Product',
  props<{ productId:string; quantity: number }>()
);

export const addToCartSuccess = createAction(
  '[Cart] Add Success',
  props<{ cart: Cart; numOfCartItems: number }>()
); 

export const removeCartProduct = createAction(
  '[Cart] Remove Product',
  props<{ productId: string }>()
); 
export const removeFromCartSuccess = createAction(
  '[Cart] Remove Success',
  props<{ cart: Cart; numOfCartItems: number }>()
); 


// Failure actions for error handling 
export const addCartProductFailure = createAction(
  '[Cart] Add Failure',
  props<{ productId: string; error?: any }>()
); 


export const removeCartProductFailure = createAction(
  '[Cart] Remove Failure',
  props<{ productId: string; error?: any }>()
);

// Clear Cart
export const clearCart = createAction('[Cart] Clear');
 

export const clearCartSuccess = createAction(
  '[Cart] Clear Cart Success'
);


// Update Cart Item Quantity
export const increaseQuantity = createAction(
  '[Cart] Increase Quantity',
  props<{ productId: string }>()
);
export const decreaseQuantity = createAction(
  '[Cart] Decrease Quantity',
  props<{ productId: string }>()
);
export const updateQuantity = createAction(
  '[Cart] Update Quantity',
  props<{ productId: string; quantity: number }>()
);

export const updateQuantitySuccess = createAction(
  '[Cart] Update Quantity Success',
  props<{ productId:string; quantity: number }>()
);



// Validate Coupon

export const validateCoupon = createAction(
  '[Cart] Validate Coupon',
  props<{ couponCode: string }>()
); 
export const validateCouponSuccess = createAction(
  '[Cart] Validate Coupon Success',
  props<{ isValid: boolean }>()
);  


// Apply Coupon
export const applyCoupon = createAction(
  '[Cart] Apply Coupon',
  props<{ couponCode: string }>()
); 
export const applyCouponSuccess = createAction(
  '[Cart] Apply Coupon Success',
  props<{ cart: Cart; numOfCartItems: number }>()
);